import App from './App.svelte';
const estateMaximizerCalculator = new App({
    target: document.getElementById("svComponent-EstateMaximizerCalculator")
});
export default estateMaximizerCalculator;
